/* eslint-disable no-lone-blocks */
import { Grid, makeStyles, Typography, useTheme } from '@material-ui/core';
import AutoCard from 'components/AutoCard';
import FilterSelector from 'components/FilterSelector';
import i18n from 'i18n';
import { PeriodCountAccess } from 'modules/dashboard/interfaces';
import {
  getEnvironmentsCostMonitorGraphRequest,
  setPeriodFilterEnvironmentsCost,
} from 'modules/monitor/actions';
import { EnvironmentsCostGraphFields } from 'modules/monitor/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import { filterPeriodOptions } from 'utils/graphs';
import { formatCurrency } from 'utils/helpers';
import EnvironmentCardGraphContent from './EnvironmentsCostGraphContent';
import styles, { overrideCardGraph, overrideFilter } from './styles';

interface EnvironmentsCostCardProps {
  environmentsCostGraphFields: EnvironmentsCostGraphFields;
  intervalTime: PeriodCountAccess;
  setPeriodFilterEnvironmentsCost: (prop: string) => void;
  getEnvironmentsCostMonitorGraphRequest: ({ intervalTime }) => void;
}

const EnvironmentsCostCard = ({
  environmentsCostGraphFields,
  intervalTime,
  setPeriodFilterEnvironmentsCost,
  getEnvironmentsCostMonitorGraphRequest,
}: EnvironmentsCostCardProps) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles({});
  const { breakpoints } = useTheme();

  React.useEffect(() => {
    getEnvironmentsCostMonitorGraphRequest({
      intervalTime,
    });
  }, [getEnvironmentsCostMonitorGraphRequest, intervalTime]);

  return (
    <Grid item className={classes.environmentsCostContainer}>
      <Grid container justify="space-between" style={{ marginBlock: '8px' }}>
        <Typography className={classes.titleCard}>
          {i18n.t('ADVISOR_PAGE.ENVIRONMENTS_COST_TITLE_KEY')}
          {': '}
          {formatCurrency(environmentsCostGraphFields?.total)}
        </Typography>
        <FilterSelector
          overrideClasses={overrideFilter}
          options={filterPeriodOptions(setPeriodFilterEnvironmentsCost)}
          currentValue={{
            label: i18n.t(
              `ENVIRONMENT_DASHBOARD.LAST_${intervalTime.toUpperCase()}`
            ),
            onClick: () => null,
          }}
        />
      </Grid>
      <Grid item className={classes.containerCard}>
        <AutoCard overrideClasses={overrideCardGraph(breakpoints)}>
          <Grid container>
            <Grid container className={classes.containerGraph}>
              <Grid item xs={12}>
                <EnvironmentCardGraphContent />
              </Grid>
            </Grid>
          </Grid>
        </AutoCard>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({
  monitor: { environmentsCostGraphFields, periodFilterEnvironmentsCost },
}: ApplicationState) => ({
  environmentsCostGraphFields,
  intervalTime: periodFilterEnvironmentsCost,
});

export default connect(mapStateToProps, {
  setPeriodFilterEnvironmentsCost,
  getEnvironmentsCostMonitorGraphRequest,
})(EnvironmentsCostCard);
